import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { ReactComponent as DownArrow } from '../../../assets/images/svg_icons/down_arrow.svg'

const Collapsible = props => {
  const [activeClass, setActiveClass] = useState('')
  return <React.Fragment>
    <div onClick={() => setActiveClass(activeClass.length ? '' : 'active')}
      className={`header__mobile-item collapsible ${activeClass}`}>
      <span>{props.title}</span>
      <DownArrow />
    </div>
    <div className={`header__mobile-item-content ${activeClass}`}>
      {
        props.subItems.map((navItem, index) => {
          return <div className='header__mobile-item' key={index}>
            <Link to={navItem.url}>{navItem.title}</Link>
          </div>
        })
      }
    </div>
  </React.Fragment>
}

export default Collapsible